<pds-module-header [title]="title" ctaLabel="Voltar" [ctaOnClick]="navigateBack.bind(this)">
  <pds-new-breadcrumb [items]="breadcrumbItems" />

  <main class="product-group-default-form-page">
    <ng-container *ngIf="isLoadingData">
      <pds-loader />
    </ng-container>

    <ng-container *ngIf="!isLoadingData">
      <pds-panel>
        <form class="product-group-default-form" [formGroup]="form" (ngSubmit)="onSubmit()">
          <!-- Seção de Grupo de Produto -->
          <pds-form-section title="Grupo de Produto">
            <pds-form-row grid="1">
              <div class="product-group-default-form__field">
                <label class="product-group-default-form__label">
                  Grupo de Produto <span class="required">*</span>
                </label>
                <pds-multi-select-autocomplete
                  formControlName="productGroup"
                  [source]="productGroupSource"
                  placeholder="Pesquisar grupos de produto"
                  (autocomplete)="onProductGroupAutocomplete($event)"
                />
              </div>
            </pds-form-row>
          </pds-form-section>

          <hr class="product-group-default-form__divider" />

          <!-- Seção de Especificações -->
          <pds-form-section title="Especificações Padrão">
            <div class="product-group-default-form__specs-helper">
              Você pode adicionar 0 ou mais especificações padrão para este grupo. O valor numérico é formatado no padrão brasileiro e a unidade é fixa por especificação.
            </div>

            <!-- Adicionar Especificação -->
            <div class="product-group-default-form__add-spec" *ngIf="availableSpecs.length > 0">
              <pds-form-field label="Escolher especificação" class="product-group-default-form__add-spec-field">
                <select [(ngModel)]="selectedSpecIdToAdd" [ngModelOptions]="{ standalone: true }">
                  <option value="">Selecione uma especificação para adicionar...</option>
                  <option *ngFor="let spec of availableSpecs" [value]="spec.id">
                    {{ spec.description }} ({{ spec.unit }}) - {{ spec.category }}
                  </option>
                </select>
              </pds-form-field>

              <button
                pdsButton="secondary"
                modifier="outlined"
                type="button"
                [disabled]="!selectedSpecIdToAdd"
                (click)="addSpec()"
              >
                <span class="icon">add</span>
                Adicionar especificação
              </button>
            </div>

            <!-- Tabela / Lista de Especificações Adicionadas -->
            <div class="product-group-default-form__specs-table" *ngIf="specs.length > 0">
              <pds-table>
                <table class="specs-fixed-table">
                  <thead>
                    <tr>
                      <th class="col-spec">Especificação</th>
                      <th class="col-category">Categoria</th>
                      <th class="col-value">Valor</th>
                      <th pdsColActions class="col-actions">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let spec of specs">
                      <td>
                        <strong>{{ spec.description }}</strong>
                      </td>
                      <td>
                        <span pdsChip>{{ spec.category }}</span>
                      </td>
                      <td>
                        <div class="spec-value-row">
                          <div class="spec-input-container">
                            <input
                              type="text"
                              class="spec-input"
                              [(ngModel)]="spec.value"
                              [ngModelOptions]="{ standalone: true }"
                              (blur)="onSpecBlur(spec)"
                              placeholder="0,000"
                            />
                            <span class="spec-unit-addon">{{ spec.unit }}</span>
                          </div>

                          <pds-checkbox
                            class="spec-overwrite-checkbox"
                            label="Sobrescrever valor"
                            [(ngModel)]="spec.overwrite"
                            [ngModelOptions]="{ standalone: true }"
                          />

                          <div *ngIf="spec.overwrite" class="spec-overwrite-warning" role="alert">
                            <span class="icon spec-overwrite-warning__icon">warning</span>
                            <span class="spec-overwrite-warning__text">
                              Vai sobrescrever o valor ignorando os valores vindos da Fraga para esta especificação.
                            </span>
                          </div>
                        </div>
                      </td>
                      <td pdsColActions>
                        <button
                          pdsButton="icon"
                          modifier="outlined"
                          type="button"
                          title="Remover especificação"
                          (click)="removeSpec(spec.id)"
                        >
                          <span class="icon">delete</span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </pds-table>
            </div>

            <div class="product-group-default-form__specs-empty" *ngIf="specs.length === 0">
              <pds-alert type="info" title="Nenhuma especificação incluída">
                Nenhuma especificação padrão foi adicionada. É possível salvar o grupo sem especificações ou selecionar acima.
              </pds-alert>
            </div>
          </pds-form-section>

          <hr class="product-group-default-form__divider" />

          <!-- Ações do formulário -->
          <pds-form-actions>
            <button pdsButton="secondary" modifier="outlined" type="button" (click)="navigateBack()">
              Cancelar
            </button>
            <button pdsButton type="submit" [disabled]="!canSubmit">
              {{ isSubmitting ? 'Salvando...' : 'Salvar' }}
            </button>
          </pds-form-actions>
        </form>
      </pds-panel>
    </ng-container>
  </main>
</pds-module-header>

<!-- Modal de Confirmação para Grupo de Produtos Já Existente -->
<pds-modal #conflictModal title="Padrão já existente" [width]="640" (dismiss)="onCancelConflict()">
  <div class="conflict-modal-content">
    <pds-alert type="warning" title="Atenção">
      Já existe um padrão configurado para o grupo de produtos
      <strong>{{ existingConflict?.productGroupName }}</strong>.
    </pds-alert>

    <div class="conflict-modal-details">
      <div class="conflict-modal-column">
        <h4 class="conflict-modal-subtitle">Valores atuais cadastrados:</h4>
        <div *ngIf="existingSpecsList.length > 0; else noCurrentSpecs" class="conflict-modal-list">
          <div *ngFor="let s of existingSpecsList" class="conflict-modal-item">
            <span class="conflict-modal-item__name">{{ s.description }}:</span>
            <strong class="conflict-modal-item__val">{{ s.value }}</strong>
          </div>
        </div>
        <ng-template #noCurrentSpecs>
          <p class="conflict-modal-empty">Nenhuma especificação cadastrada anteriormente.</p>
        </ng-template>
      </div>

      <div class="conflict-modal-column">
        <h4 class="conflict-modal-subtitle">Novos valores que serão aplicados:</h4>
        <div *ngIf="pendingSpecsList.length > 0; else noNewSpecs" class="conflict-modal-list">
          <div *ngFor="let s of pendingSpecsList" class="conflict-modal-item">
            <span class="conflict-modal-item__name">{{ s.description }}:</span>
            <strong class="conflict-modal-item__val">{{ s.value }}</strong>
          </div>
        </div>
        <ng-template #noNewSpecs>
          <p class="conflict-modal-empty">Nenhuma especificação (0 especificações).</p>
        </ng-template>
      </div>
    </div>

    <p class="conflict-modal-question">
      Deseja <strong>sobrescrever</strong> o padrão existente com estes novos valores ou <strong>cancelar</strong>?
    </p>

    <pds-form-actions>
      <button pdsButton="secondary" modifier="outlined" type="button" (click)="onCancelConflict()">
        Cancelar
      </button>
      <button pdsButton="primary" type="button" [disabled]="isOverwriting" (click)="onOverwriteConflict()">
        {{ isOverwriting ? 'Sobrescrevendo...' : 'Sobrescrever' }}
      </button>
    </pds-form-actions>
  </div>
</pds-modal>
